import { CircularProgress, TextField, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { AutocompleteSingle } from '../../../../../../components/Autocomplete';
import { useErrorLogger } from '../../../../../../hooks/useErrorLogger';
import {
  matchUserBySearchTerm,
  toFullName,
  toSearchTermRegexp,
  useUsersByOrgId
} from '../../../../../../services/user';

export const AutocompleteUserId = ({
  label,
  placeholder,
  orgId,
  value,
  onChange,
  disabled,
  error,
  helperText
}: {
  label: string;
  placeholder: string;
  orgId: string;
  value: string;
  onChange: (nextValue: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const [users, loading, loadError] = useUsersByOrgId(orgId);
  const selectedUser = useMemo(
    () => (users ? users.find((u) => u.id === value) || null : null),
    [value, users]
  );

  useErrorLogger('AutocompleteUserId', loadError);

  if (loading) {
    return (
      <TextField
        variant="outlined"
        fullWidth
        label={label}
        placeholder={placeholder}
        InputProps={{
          endAdornment: <CircularProgress color="inherit" size={20} />
        }}
      />
    );
  }
  if (users) {
    return (
      <AutocompleteSingle
        value={selectedUser}
        disabled={disabled}
        error={error}
        helperText={helperText}
        placeholder={placeholder}
        onChange={(v) => onChange(v ? v.id : '')}
        options={users}
        getOptionLabel={(o) => toFullName(o.data)}
        renderOption={(o) => (
          <div>
            <div>{toFullName(o.data)}</div>
            <Typography variant="caption">
              {[o.data.role, o.data.department, o.data.location]
                .filter((x) => x)
                .join(' • ')}
            </Typography>
          </div>
        )}
        filterOptions={(os, s) => {
          const re = toSearchTermRegexp(s.inputValue);
          return os.filter((o) => matchUserBySearchTerm(re, o));
        }}
        label={label}
        fullWidth
      />
    );
  }

  return null;
};
